module.exports = __webpack_public_path__ + "b56bea4ec4e46dd8760c92b3e5ccfc76.jpg";